import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableDirectDeposit extends Layout {
    sourceDirectDeposit: DataSource;
    tableDirectDeposit: Table;
}
